export enum CrashMatchSortMode {
    Created = "Created",
    Relevance = "Relevance"
}
